import createVueApp from '@phoenix/createVueApp';
import StrapCompatibilityForm from '@maison/components/strap-search/StrapCompatibilityForm.vue';

const app = createVueApp({}, true);
app.component('StrapCompatibilityForm', StrapCompatibilityForm);
app.mount('#phoenix-strap-compatibility-form');
